import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from '../Modules.State';
import ModulesAction from '../Modules.Action';
import withRouter from 'src/routes/withRouter';
import { Button, Input, Tree } from 'antd';
import { create } from 'kts-scaffold-framework/utils/form';
import Icon from 'src/display/components/Icon';
const { TreeNode, DirectoryTree } = Tree;

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}


/** 绑定全局数据 */
@create()
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class Head extends UIBasic<IProps, ModulesState> {
    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentDidMount(){
        this.modulesState.companyUserSearch = '';
        this.modulesState.departmentFilterListByCommanyUser  = this.modulesState.departtreeDate;
        this.setModulesState();
    }
    /**
     * 
     * @param list 遍历数组生成树形节点
     * @returns 
     */
     getDomByTree = (list: any = []) => {
        const dom = list.length > 0 ? list.map((item) => {
            return this.getTreeNode(item, true, this.getUserTreeNode(item.departmentId));
        }) : null;
        return dom;
    }
    /**
     * 返回属性节点DOm
     * @param item 
     * @param isNodeOpen 
     * @param userDom 
     * @returns 
     */
    getTreeNode = (item: any, isNodeOpen = false, userDom: any = null) => {
        return (
            <TreeNode title={item.name} key={item.key} expanded={true}>
                {userDom}
                {this.getDomByTree(item.children)}
            </TreeNode>
        );
    }

    getUserTreeNode = (departmentId: string) => {
        const list = this.modulesState.companyUserFilterList;
        if (list.length > 0) {
            return list.filter(item => item.departmentId === departmentId)
                .map(item => {
                    const flag = this.modulesState.activeUserObjects.some(i => i === item.userId);
                    let classN = `${css.antdBtn}`;
                    if (flag) {
                        classN = `${css.antdBtnGhost}`;
                    }
                    const textDom = (
                        <span className={css.textDom}>
                            <span className={css.title} >{item.nickName}</span>
                            <Button
                                type="primary"
                                shape="round"
                                size="small"
                                className={`${css.flr} ${classN}`}
                                onClick={()=>{ModulesAction.setPowerHandle(item,!flag);}}
                            >
                                {flag ? '移除' : '添加'}
                            </Button>
                        </span>);
                    return <TreeNode icon={<Icon src={require('./Icon/img.user.svg')} />} className={css.treeNode} title={textDom} key="0-0-0" isLeaf={true} ></TreeNode>;
                });
        }
        return null;
    }
    updateDomTree = () => {
        this.modulesState.domTree = this.getDomByTree(this.modulesState.departtreeDate);
        this.setModulesState();
    }
    searchFn = (e: any = null) => {
        const val = e.target.value;
        let filterList = [];
        if (!val) {
            filterList = this.modulesState.companyUserList;
        } else {
            filterList = this.modulesState.companyUserList.filter(item => item.nickName.indexOf(val) !== -1);
        }
        this.modulesState.companyUserFilterList = filterList;
        this.modulesState.companyUserSearch = val;
        this.modulesState.treeId = new Date().getTime()+'companyUser';
        this.modulesState.domTree = null;
        this.setModulesState(this.modulesState,()=>{
            ModulesAction.getDepartmentFilterListByCompanyUser();
        });
        // this.updateDomTree();
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        // const domTree = this.getDomByTree(this.modulesState.departtreeDate);
        const defaultExpandedKeys = this.modulesState.departtreeDate && this.modulesState.departtreeDate.map(item => item.key);
        return (
            <div className={css.setPowerContent}>
                <div>
                    {getFieldDecorator('appName', {
                        initialValue: this.modulesState.companyUserSearch
                    })(
                        <Input
                            placeholder="搜索人员"
                            prefix={<Icon className={css.searchIcon} src={require('./Icon/img.search.svg')} />}
                            onPressEnter={(e) => this.searchFn(e)}
                        />
                    )}
                </div>
                {/* {this.modulesState.domTree ? this.modulesState.domTree : this.getDomByTree(this.modulesState.departtreeDate)} */}
                {
                    this.modulesState.domTree ?
                        <DirectoryTree
                            defaultExpandedKeys={defaultExpandedKeys}
                            blockNode={true}
                            showIcon={true}
                            defaultExpandAll={false}
                            onSelect={() => { }}
                            selectable={false}
                            key={this.modulesState.treeId}
                        >
                            {this.modulesState.domTree}
                        </DirectoryTree> :
                        <DirectoryTree
                            defaultExpandedKeys={defaultExpandedKeys}
                            blockNode={true}
                            showIcon={true}
                            defaultExpandAll={false}
                            onSelect={() => { }}
                            selectable={false}
                            key={this.modulesState.treeId}
                        >
                            {this.getDomByTree(this.modulesState.departmentFilterListByCommanyUser)}
                        </DirectoryTree>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManage/UI.SetPower/UI.CompanyUser.tsx